<template>
	<div class="content">
		<div class="section-banner">
			<img class="img-fluid" src="../../../assets/img/magic/001.jpg" />
		</div>
		<div class="section section-pading section1">
			<img class="img-fluid" src="../../../assets/img/magic/002.jpg" />
		</div>
		<div class="section2">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide"><img class="img-fluid" src="../../../assets/img/magic/003-1.jpg"></div>
					<div class="swiper-slide"><img class="img-fluid" src="../../../assets/img/magic/003-2.jpg"></div>
					<div class="swiper-slide"><img class="img-fluid" src="../../../assets/img/magic/003-3.jpg"></div>
				</div>
				<div class="swiper-pagination swiper-pagination-white" id="swiper-spit"></div>
				<div class="swiper-button-next"></div>
				<div class="swiper-button-prev"></div>
			</div>
		</div>
		<div class="section section-pading section3">
			<img class="img-fluid" src="../../../assets/img/magic/004.jpg">
		</div>
		<div class="section section4">
			<img class="img-fluid" src="../../../assets/img/magic/005.jpg">
		</div>
		<div class="section section-pading section5">
			<img class="img-fluid" src="../../../assets/img/magic/006.jpg">
		</div>
		<div class="section section6" style="padding: 50px 0 90px;">
			<img class="img-fluid" src="../../../assets/img/magic/007.jpg">
		</div>
		<div class="section section-pading section8">
			<div class="section-title" style="margin-top: 40px; margin-bottom: 20px;">
				<h3 style="color: #727171;">产 品 视 频<span></span></h3>
			</div>
			<div class="container">
				<div class="swiper-container" style="margin-bottom: 36px;">
					<div class="swiper-wrapper">
						<div class="swiper-slide" style="width: 720px; margin-right: 25px;">
							<video width="100%" poster="../../../assets/img/magic/video01.jpg" controls="" preload="metadata" autobuffer="">
								<source src="https://video.itmsw.cn/a094158bvodtransgzp1252902618/a36d5c605285890804001267325/v.f100040.mp4" type="video/webm">
								<source src="https://video.itmsw.cn/a094158bvodtransgzp1252902618/a36d5c605285890804001267325/v.f100040.mp4" type="video/mp4">
							</video>
							<br>
							<h3>AI MAGIC 创想未来</h3>
						</div>
					</div>
					<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.css'
	import 'swiper/dist/js/swiper.min.js'
	export default {
		name: 'MagicContent',
		mounted() {
			var swiper = new Swiper('.section2 .swiper-container', {
				spaceBetween: 0,
				loop: true,
				autoplay: {
					delay: 5000,
					disableOnInteraction: true, // 取消鼠标操作后的轮播暂停【无操作轮播继续】【参考链接1】
					stopOnLastSlide: false, // 在最后一页停止
				},
				pagination: {
					el: '.section2 .swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.section2 .swiper-button-next',
					prevEl: '.section2 .swiper-button-prev',
				}
			});

			var swiper2 = new Swiper('.section6 .swiper-container', {
				spaceBetween: 0,
				loop: true,
				autoplay: {
					delay: 5000,
					disableOnInteraction: true, // 取消鼠标操作后的轮播暂停【无操作轮播继续】【参考链接1】
					stopOnLastSlide: false, // 在最后一页停止
				},
				pagination: {
					el: '.section6 .swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.section6 .swiper-button-next',
					prevEl: '.section6 .swiper-button-prev',
				}
			});
		}
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/css/magic/components/MagicContent.scss';
</style>